import { render } from "./breadcrumbs.vue?vue&type=template&id=4a8b8a06"
import script from "./breadcrumbs.vue?vue&type=script&lang=js"
export * from "./breadcrumbs.vue?vue&type=script&lang=js"

import "./breadcrumbs.vue?vue&type=style&index=0&id=4a8b8a06&lang=css"

import exportComponent from "/Users/jean-yvesfournet/Documents/projects/javascript/vue/shop-flash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__